<template>
    <StepTemplate :activeStepNr="this.activeStepNr"
                  :myStepNr="this.myStepNr"
                  :value="value"

    >v-model
        <template slot="slide-form">
            <!--
            <div @click="test()">[TEST]</div>
            <div @click="test2()">[TEST2]</div>
            -->

            <form data-vv-scope="xxx"  @click.alt="testFillForm()">
                <!--============================================================================================================ -->
                <v-layout row>
                    <v-flex xs12 style=" font-size: 0.9em;">
                        <Anzeigepflicht-Block><!-- TextBlock mit Hinweis zur Pflicht alle Daten korrekt anzugeben--></Anzeigepflicht-Block>
                    </v-flex>
                </v-layout>
                <!------------------------------------------------------------------------------------------------------------>

                <v-layout row>
                    <Rechner-hint-col>
                        <b>Versicherungsbeginn:</b>
                        <br>Der Beginn ist frühestens am nächsten Tag möglich.
                        <br>Der Versicherungsbeginn sollte jedoch maximal einen Tag später sein, zu dem Ihre bisherige Versicherung aufgehoben wurde.
                        <br>
                        <b>Zahlweise:</b>
                        <br>Hier können Sie wählen, ob der Versicherungs-Beitrag einmal im Jahr, halbjährlich oder vierteljährlich gezahlt werden soll.
                        <br>Eine monatliche Zahlweise ist nicht möglich.
                        <br>

                    </Rechner-hint-col>
                    <v-flex xs5>
                        <Rechner-field-col :fielddef="fieldDefs.vertrag_beginn" v-model="value.fieldValues"
                                           :$v="$v"></Rechner-field-col>
                    </v-flex>
                    <v-flex xs5>
                        <Rechner-field-col :fielddef="fieldDefs.vertrag_zahlungsweise" v-model="value.fieldValues"
                                           :$v="$v"></Rechner-field-col>
                    </v-flex>
                </v-layout>

                <!------------------------------------------------------------------------------------------------------------>

                <v-layout row>
                    <Rechner-hint-col>
                        <b>Anzahl:</b>
                        <br>Die Anzahl der zu versichernden Pferde
                        <br>
                        <b>Geburtsdatum des Halters:</b>
                        <br>Der Halter muss zu Vertragsbeginn midestens 18 Jahre alt sein
                        <br>
                        <br>Ab 60 Jahre bieten wir vergünstigte Tarife an.
                    </Rechner-hint-col>
                    <v-flex xs5>
                        <Rechner-field-col :fielddef="fieldDefs.thvp_pferd__anzahl" v-model="value.fieldValues"
                                           :$v="$v"></Rechner-field-col>
                    </v-flex>
                    <v-flex xs5>
                        <Rechner-field-col :fielddef="fieldDefs.thvp_halter_geburtsdatum" v-model="value.fieldValues"
                                           :$v="$v"></Rechner-field-col>
                    </v-flex>
                </v-layout>
                <!--============================================================================================================ -->
                <!--============================================================================================================ -->
                <v-layout row class="section_header">
                    <v-flex xs11>
                        <!--============================================================================================================ -->
                        <v-tabs light class="elevation-0"
                                v-model="activeTabIndex"
                                color="grey lighten-2"
                                centered
                                slider-color="blue"
                        >
                            <v-tab v-for="i in  parseInt(value.fieldValues.thvp_pferd__anzahl,10)"
                                   :key="i"
                                   ripple
                            >
                                {{i}}. pferd <span class="tabhint" v-if="!pferdValid(i)">unvollständig !</span>
                                <!-- <span v-if="tabStatus[i]" class="expansion-panel-hint">schließen</span>
                                <span v-else class="expansion-panel-hint">öffnen</span>
                                -->

                            </v-tab>
                            <!--******************************************************************************************************* -->
                            <v-tab-item
                                    :key="i"
                                    v-for="i in  parseInt(value.fieldValues.thvp_pferd__anzahl,10)"
                                    @click.native="dummy()"
                            >
                                <v-layout row>
                                    <Rechner-hint-col>
                                        Name des zu versichernden Pferdes
                                        <br>
                                        <br>
                                        Rasse des zu versichernden Pferdes
                                    </Rechner-hint-col>
                                    <v-flex xs5>
                                        <Rechner-field-col :fielddef="fieldDefs['thvp_pferd__'+i+'__name']"
                                                           v-model="value.fieldValues"
                                                           :$v="$v"></Rechner-field-col>
                                    </v-flex>
                                    <v-flex xs5>
                                        <Rechner-field-col :fielddef="fieldDefs['thvp_pferd__'+i+'__rasse']"
                                                           v-model="value.fieldValues"
                                                           :autocomplete="true"
                                                           :$v="$v"></Rechner-field-col>
                                    </v-flex>
                                </v-layout>


                                <!--******************************************************************************************************* -->

                            </v-tab-item>
                            <!--******************************************************************************************************* -->
                        </v-tabs>
                        <!--============================================================================================================ -->

                    </v-flex>
                </v-layout>
                <!--============================================================================================================-->
            </form>

        </template>
    </StepTemplate>
</template>
<!-- _____________________________________________________________________________________________________________________________________________________________ -->
<!-- ############################################################################################################################################################# -->
<script>
    import slideMixin from '../stepMixin'
    import _ from 'lodash'
    //import VBtn from "../../../../node_modules/vuetify/src/components/VBtn/VBtn.vue";

    //import {mapState} from 'vuex'

    export default {
        //========================================================================================================
        name: 'thpferd-Daten',
        label: 'thpferd-Daten',
        label2: 'thpferd<br>Daten',
        fieldKeys: [
            'vertrag_zahlungsweise',
            'vertrag_beginn',

            'thvp_halter_geburtsdatum',

            'thvp_pferd__anzahl',
            'thvp_pferd__1__name',
            'thvp_pferd__1__rasse',


        ],
        //========================================================================================================
        data: function () {
            //fieldDefs wird in StepMixin mit den Werten aus der Datenbank belegt,
            //an dieser Stelle können diese Werte überschrieben werden.
            // Vue merged von alleine die Werte aus 'stepMixin' und denen aus 'fieldDefs_OVERRIDE'
            var fieldDefs_OVERRIDE = {}

            return {
                fieldDefs: fieldDefs_OVERRIDE,
                forceUpdateDummy: 1,
                activeTabIndex: '0',
            }
        }, //========================================================================================================
        mixins: [slideMixin],
        //===========================================================================================================
        computed: {},
        //===========================================================================================================
        methods: {
            dummy: function () {
                return null
            }, //___________________________________________________________________________________________________________
            calcProgression: function (percent, val) {
                this.$numeral.locale('de')
                var numeralVal = this.$numeral(val).value()
                var progressionValue = percent / 100 * numeralVal
                var result = this.$numeral(progressionValue).format('0,')
                return result
            }, //___________________________________________________________________________________________________________

            pferdValid: function (pferdNr) {
                var v = this.$v.value.fieldValues
                var fields = [
                    '__name',
                    '__rasse',


                ]
                var valid = true
                for (var i in fields) {
                    var field = fields[i]
                    var fieldValid = !v['thvp_pferd__' + pferdNr + field].$error
                    valid = valid && fieldValid
                    //console.log("&&&&&&&&&&&&&&&", field, valid, fieldValid)
                }

                return valid

            },
            /*
            //___________________________________________________________________________________________________________
            get_vollinvalide: function (pferdNr) {
              var invaliditat = parseInt(this.value.fieldValues['thvp_pferd__' + pferdNr + '__betrag_invalide'], 10)
              var progression = parseInt(this.value.fieldValues['thvp_pferd__' + pferdNr + '__progression'], 10)
              var vollinvalid = parseInt(invaliditat * progression / 100, 10)
              if (vollinvalid > 0) {
                return vollinvalid
              } else {
                return 0
              }

            },
            */
            //___________________________________________________________________________________________________________
            add_pferd: function (oldCount, newCount) {

                console.log('######## RAD+ ###############')
                if (!oldCount) {
                    oldCount = parseInt(this.value.fieldValues.thvp_pferd__anzahl, 10)
                }
                if (!newCount) {
                    newCount = parseInt(this.value.fieldValues.thvp_pferd__anzahl, 10) + 1
                }

                _.forEach(this.$options.fieldKeys, (fieldName) => {
                    console.log(fieldName, fieldName.indexOf('thvp_pferd__'))
                    if ((/thvp_pferd__1__(.*)/g).exec(fieldName) && fieldName !== 'thvp_pferd__anzahl') {
                        for (var currentCount = oldCount + 1; currentCount <= newCount; currentCount++) {
                            console.log('add pferd up to:', currentCount)

                            var new_Def = _.assign({}, this.$store.state.rechnerConfig.fieldDefs[fieldName])
                            new_Def.name = new_Def.name.replace('1__', currentCount + '__')

                            console.log('new_Def', new_Def)

                            var new_DefValidateString = JSON.stringify(new_Def.validate).replace(/1__/g, currentCount + '__')
                            new_Def.validate = JSON.parse(new_DefValidateString)
                            this.$options.fieldKeys.push(new_Def.name)
                            console.log('&&& 1', new_Def.name)
                            this.fieldDefs[new_Def.name] = new_Def
                            this.$store.commit('add_FieldDef', {data: new_Def})
                            console.log('&&& 2')

                            var defaultValue = new_Def.default_value
                            if (defaultValue !== null && defaultValue !== undefined) {
                                defaultValue = String(defaultValue)
                            }

                            this.$set(this.value.fieldValues, new_Def.name, defaultValue)
                            console.log('&&& 3')

                        }
                    }

                })

                console.log('&&& 4')
                this.forceUpdateDummy = this.forceUpdateDummy + 1
                this.$v.$reset()
                //this.$nextTick(() => {
                // this.value.fieldValues.thvp_pferd__anzahl = currentCount
                //})
                console.log('&&& 5')

            }, //___________________________________________________________________________________________________________
            remove_pferd: function (oldCount, newCount) {

                if (!oldCount) {
                    oldCount = parseInt(this.value.fieldValues.thvp_pferd__anzahl, 10)
                }
                if (!newCount) {
                    newCount = parseInt(this.value.fieldValues.thvp_pferd__anzahl, 10) + 1
                }


                var maxIndex = (newCount - 1)
                var currentIndex = this.activeTabIndex
                this.activeTabIndex = currentIndex > maxIndex ? maxIndex : currentIndex
                this.$forceUpdate()

                _.forEach(this.$options.fieldKeys, (fieldName) => {
                    console.log(fieldName, this.$options.fieldKeys)
                    //console.log(fieldName, fieldName.indexOf("thvp_pferd__"))
                    if ((/thvp_pferd__1__(.*)/g).exec(fieldName) && fieldName !== 'thvp_pferd__anzahl') {
                        for (var currentCount = oldCount - 1; newCount <= currentCount; currentCount--) {
                            console.log('remove pferd down to:', currentCount)

                            var removeFieldName = fieldName.replace('1__', (currentCount + 1) + '__')

                            _.remove(this.$options.fieldKeys, function (n) {
                                return (n === removeFieldName)
                            })

                            _.unset(this.fieldDefs, removeFieldName)

                            this.$store.commit('remove_FieldDef', {data: removeFieldName})
                            console.log('&&& 2', removeFieldName)

                            this.$delete(this.value.fieldValues, removeFieldName)
                            console.log('&&& 3')
                        }
                    }
                })

                this.$v.$reset()
                console.log('&&& 4')
                this.forceUpdateDummy = this.forceUpdateDummy + 1


                console.log('&&& 5')


            },  //___________________________________________________________________________________________________________
            test: function () {

                this.forceUpdateDummy = this.value.fieldValues.thvp_pferd__1__geburtsdatum
                this.value.fieldValues.thvp_pferd__1__geburtsdatum = ' '
                this.$forceUpdate()

            },
            test2: function () {

                this.value.fieldValues.thvp_pferd__1__geburtsdatum = this.forceUpdateDummy
                this.$forceUpdate()
            },
        }, //========================================================================================================
        watch: {

            value: {
                handler: function (newVal, oldVal) {
                    console.log('~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~')
                    console.log('WATCHER fieldValues in ', this.$options.label)
                    var fV = this.value.fieldValues
                    var fVold = this.frmValuesOld
                    // var fD = this.fieldDefs
                    var earlyExit = true
                    for (var key in fV) {
                        if (fV[key] !== fVold[key]) {
                            earlyExit = false
                            console.log('changed ', key, fVold[key], '->', fV[key])

                        }
                    }
                    if (earlyExit === true) {
                        console.log('NO changes -> early EXIT in Unfall_I')
                        return
                    }
                    //----------------------------------------------------------------------------
                    var newCounter = parseInt(this.value.fieldValues['thvp_pferd__anzahl'], 10)
                    var oldCounter = parseInt(fVold['thvp_pferd__anzahl'], 10)
                    if (newCounter > oldCounter) {
                        console.log('pferdCounter Increase:', oldCounter, '=>', newCounter)
                        this.add_pferd(oldCounter, newCounter)
                    }
                    if (newCounter < oldCounter) {
                        console.log('Counter decrease', newCounter, '<=', oldCounter)
                        this.remove_pferd(oldCounter, newCounter)
                        console.log('Counter decrease DONE')
                    }
                    //----------------------------------------------------------------------------
                    /*
                    var newAgeGroup = this.value.fieldValues['uvr_altersgruppe']
                    var oldAgeGroup = fVold['uvr_altersgruppe']
                    //nötiger Hack, da das "Validate" vom Geburtstag nicht aktualisiert, nach dem man Altergruppe geändert hat
                    if (newAgeGroup !== oldAgeGroup) {
                      console.log("# # # # Alters-Gruppe geändert")
                      var count = parseInt(this.value.fieldValues.thvp_pferd__anzahl, 10)
                      var oldDates = []
                      for (var i = 1; i <= count; i++) {
                        oldDates[i] = this.value.fieldValues['thvp_pferd__' + i + '__geburtsdatum']
                        this.value.fieldValues['thvp_pferd__' + i + '__geburtsdatum'] = ""
                        this.value.fieldValues['thvp_pferd__' + i + '__betrag_ueberg_leist'] = null
                        this.value.fieldValues['thvp_pferd__' + i + '__betrag_rente'] = null
                        this.value.fieldValues['thvp_pferd__' + i + '__progression'] = 100
                      }

                      this.$nextTick(() => {
                        for (var i = 1; i <= count; i++) {
                          this.value.fieldValues['thvp_pferd__' + i + '__geburtsdatum'] = oldDates[i]
                        }
                      })


                    }
                    */
                    //----------------------------------------------------------------------------

                    //----------------------------------------------------------------------------
                    /*
                    var radCount = parseInt(this.value.fieldValues.thvp_pferd__anzahl, 10)
                    console.log("checks for " + radCount + " Räder :")
                    for (var radNr = 1; radNr <= radCount; radNr++) {
                      console.log("WATCHER: for Rad Nr " + radNr)
                      var newKat = this.value.fieldValues['thvp_pferd__kategorie_' + radNr]
                      var oldKat = fVold['thvp_pferd__kategorie_' + radNr]

                      if (newKat === 'KatTeile' && oldKat !== newKat) {
                        // this.value.fieldValues['thvp_pferd__marke_' + radNr] = "-/-";
                        this.value.fieldValues['thvp_pferd__typ_' + radNr] = "-/-";
                        this.value.fieldValues['thvp_pferd__baujahr_' + radNr] = "2200";
                        this.value.fieldValues['thvp_pferd__teileart_' + radNr] = null;
                        console.log("WATCHER: set kategorie auf 'KatTeile' => set uneeded to -/-")
                      }
                      if (newKat !== 'KatTeile' && oldKat === 'KatTeile') {
                        // this.value.fieldValues['thvp_pferd__marke_' + radNr] = null;
                        this.value.fieldValues['thvp_pferd__typ_' + radNr] = null;
                        this.value.fieldValues['thvp_pferd__baujahr_' + radNr] = null;
                        this.value.fieldValues['thvp_pferd__teileart_' + radNr] = "-/-";
                        console.log("WATCHER: set kategorie NOT 'KatTeile' => set uneeded to -/-")
                      }

                    }
                    */
                    //----------------------------------------------------------------------------
                    this.frmValuesOld = _.assign({}, fV)

                },
                deep: true,

            },
        }, //========================================================================================================
        components: {/* programmatically setted by step-mixin*/},
        //===========================================================================================================
        props: [/* programmatically setted by step-mixin*/],
        //===========================================================================================================
        // HOOKS:
        /* programmatically setted by step-mixin*/
        //===========================================================================================================
    }
</script>
<!-- ############################################################################################################################################################# -->
<!-- ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯ -->
<style lang="stylus">


    .v-tabs__item.v-tabs__item--active {
        background-color: #d2d2d2;
        box-shadow: inset 0px 0px 16px 3px #b8b8b8;
    }

    .v-tabs__slider-wrapper {
        z-index: 1;
        box-shadow: 0px 0px 16px 3px #e0edf7;
    }

    .v-tabs {
        /* box-shadow: 0 2 px 4 px - 1 px rgba(0, 0, 0, .2), 0 4 px 5 px 0 rgba(0, 0, 0, .14), 0 1 px 10 px 0 rgba(0, 0, 0, .12) !important; */
    }

    .v-tabs__div a {
        padding: 4px 15px 10px 15px;

    }

    .v-tabs__container--fixed-tabs .tabs__div, .tabs__container--icons-and-text .tabs__div, .tabs__container--centered .tabs__div {
        min-width: auto;
    }

    .tabhint {
        position: absolute;
        margin: 0 0 0 5px;
        bottom: 3px;
        color: red;
        text-transform: none;
        font-size: .9em;
    }

    /*
    .input-group--text-field:not(.input-group--single-line).input-group--focused:not(.input-group--textarea) label, .input-group--text-field:not(.input-group--single-line).input-group--placeholder:not(.input-group--textarea) label,
    .input-group--text-field.input-group--dirty.input-group--select label, .input-group--text-field.input-group--dirty:not(.input-group--textarea) label {
        max-width: 130%;
        width: 130%;
    }
    */

    .input-group--single-line.input-group--focused label {
        opacity: .3 !important;
    }

    /*  .input-group.input-group--append-icon label, .input-group.input-group--selection-controls label
    */

    .v-input.progression > div {
        width: 100%;
    }

    /*
        .expansion-panel-hint {
            position: absolute;
            position: absolute;
            top: 16px;
            right: 29px;
            font-size: 0.7em;
            color: #8d8d8d;
            font-weight: normal;
            font-style: italic;
        }

        .expansion-panel__container {
            width: 100%
        }

        .expansion-panel__header {
            padding: 0;
            margin: 0 7.6% 0px -0.5%;
        }

        .expansion-panel__header .header__icon {
            position: absolute;
            right: 0;
            top: 8px;
        }

        .expansion-panel__header div {
            text-align: center;
            padding: 5px;
            font-size: 1.45em;
            font-weight: normal;
            line-height: 1em;
            letter-spacing: 0.02em;
        }

        .expansion-panel__body {
            margin: 0px 15px 0 -3px;
        }
        */
</style>
